module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/hairmake_sns_04-7b8175c942860a5e08d9bc6321ad2441.jpg";